import { TireBrand } from './TireBrand';
import { TireSize } from './TireSize';
import { TireWear } from './TireWear';
import { TireWidth } from './TireWidth';
import { TirePatternGroup } from './TirePatternGroup';
import { TirePattern } from './TirePattern';
import { TireStoringInfo, TireTypeEnum } from './info';

export class TireStoringContractSeasonInfo {
  public id?: string;
  public contractId?: string;
  public tireType?: TireTypeEnum;
  public tireBrand?: TireBrand | null = null;
  public tireSize?: TireSize | null = null;
  public tireWear?: TireWear | null = null;
  public tireWidth?: TireWidth | null = null;
  public tirePatternText?: string;
  public tirePatternGroup?: TirePatternGroup | null = null;
  public tirePattern?: TirePattern | null = null;
  public tires: TireStoringInfo[] = [];
  public wheelSize?: string;
  public wheelBrand?: string;

  // Client only
  public items?: any = [];

  constructor(init?: Partial<TireStoringContractSeasonInfo>) {
    Object.assign(this, init);
  }
}
